// src/services/userAdminApi.js
// --- UPDATE (User Management) ------------------------------------------------------------
// Client for /api/v1/users (backend services/userAdminService.js). Every call sends the signed-in
// token; errors throw with the server's message and HTTP status.
// --- END UPDATE ---------------------------------------------------------------------------
import { config } from '../config';
import { getAuthToken } from '../utils/auth';

const BASE = `${config.apiUrl}/users`;

async function call(path, { method = 'GET', body } = {}) {
    const res = await fetch(`${BASE}${path}`, {
        method,
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getAuthToken() || ''}` },
        body: body === undefined ? undefined : JSON.stringify(body),
    });
    let json = {};
    try { json = await res.json(); } catch { json = {}; }
    if (!res.ok) {
        const msg = json.message || (Array.isArray(json.errors) ? json.errors.map((e) => e.msg).join(', ') : null) || `Request failed (${res.status})`;
        const err = new Error(msg);
        err.status = res.status;
        throw err;
    }
    return json.data !== undefined ? json.data : json;
}

const qs = (o = {}) => {
    const s = Object.entries(o).filter(([, v]) => v !== undefined && v !== null && v !== '' && v !== 'all').map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&');
    return s ? `?${s}` : '';
};

export const userAdminApi = {
    directory: (filters) => call(`/directory${qs(filters)}`),
    catalog: () => call('/roles/catalog'),
    insights: () => call('/insights'),
    create: (body) => call('', { method: 'POST', body }),
    updateProfile: (id, body) => call(`/${encodeURIComponent(id)}/profile`, { method: 'PATCH', body }),
    setStatus: (id, status) => call(`/${encodeURIComponent(id)}/status`, { method: 'POST', body: { status } }),
    resetPassword: (id, body) => call(`/${encodeURIComponent(id)}/reset-password`, { method: 'POST', body }),
    changeMyPassword: (current_password, new_password) => call('/me/password', { method: 'POST', body: { current_password, new_password } }),
    bulk: (ids, action, value) => call('/bulk', { method: 'POST', body: { ids, action, value } }),
    audit: (id) => call(`/${encodeURIComponent(id)}/audit`),
    remove: (id) => call(`/${encodeURIComponent(id)}/account`, { method: 'DELETE' }),
};

export default userAdminApi;
